export const DEFAULT_BREDS = []
export const DEFAULT_BREEDING_CONFIG = {
    ivsCount: 5,
    nature: false,
    isBreeding: false,
    iv: {}
}
export const BREEDING_FORM_VALUES = {
    nature: {
        iv: {
            5: [2, 11, 10, 6, 2],
            4: [6, 5, 3, 1, 0],
            3: [4, 2, 1, 0, 0],
            2: [2, 1, 0, 0, 0],
            1: [1, 0, 0, 0, 0]
        }
    },
    random: {
        iv: {
            5: [2, 5, 5, 3, 1],
            4: [2, 3, 2, 1, 0],
            3: [2, 1, 1, 0, 0],
            2: [1, 1, 0, 0, 0]
        }
    }
}